<template>

  <div class="content">
    <div class="topHeader">
      <img src="/static/img/index/back.png" alt="" class="backImg" @click="modal = true" />
      <div class="title">订单支付 </div>
    </div>
    <div class="topCen">
      <div class="box-img">
        <!-- <img src="/static/img/index/back.png" alt="" class="ic-arrow-line-leftImg" @click="modal = true" /> -->
        <div class="topCircleBg">
          <div class="detailImg"><img :src="$baseUrl+detail.image" alt="" class="" /></div>
          <div class="topnameDiv">
            <div class="topname">{{ detail.opusName }}</div>
            <!-- 盲盒最多可能掉落  个藏品-->
          </div>

        </div>
      </div>
      <div class="box-info">
        <article class="buy-info">
          <section class="customer-info">
            <p class="name">
              <span class="lf">{{$t('payment.customerInfo1')}}</span>
              <!--收货人-->
              <span class="rt">
                {{  detail.customerName }}
              </span>
            </p>
            <p class="money">
              <span class="lf">{{$t('payment.customerInfo2')}}</span>
              <!--支付金额-->
              <span class="rt">
                <em v-if="paySourceType != 4" class="text">{{$t('public.money')}}</em>
                <em v-if="paySourceType == 4" class="img"></em>
                <b>{{ detail.totalPrice | filterMoney }}</b>
              </span>
            </p>
          </section>
        </article>
        <div class="selectPayCon">
          <template v-if="!iosReviewVerify">
            <section class="pay-methods" v-if="alipaychannel != 0" @click="selectPayFn(1)">
              <!-- 支付宝 -->
              <a class="zhifubaoPay">
                <img src="/static/img/payment/alipay.png" alt="" class="apliyIcon">
                <p class="text">
                  {{$t('payment.apliyCheckFn')}}
                </p>
                <img
                  :src="paySourceType == 1? '/static/img/payment/select-check.png' : '/static/img/payment/select-off.png'"
                  alt="" class="selectIcon">
              </a>
            </section>
            <section v-if="false" class="pay-methods" @click="selectPayFn(2)">
              <!-- 微信 -->
              <a class="zhifubaoPay">
                <img src="/static/img/payment/wepay.png" alt="" class="apliyIcon">
                <p class="text">
                  微信支付
                </p>
                <img
                  :src="paySourceType == 2? '/static/img/payment/select-check.png' : '/static/img/payment/select-off.png'"
                  alt="" class="selectIcon">
              </a>
            </section>
            <section class="pay-methods" v-if="bankpaychannel != 0 && $store.state.token" @click="selectPayFn(3)">
              <a class="zhifubaoPay">
                <img src="/static/img/payment/bankl.png" alt="" class="apliyIcon">
                <!--  银行卡快捷支付 -->
                <p class="text">
                  <span>{{$t('payment.bankCheckFn')}}</span>
                  <span class="sale" v-if="bankPaySaleObj.status">最多可减免{{bankPaySaleObj.max /100}}元</span>
                </p>
                <img
                  :src="paySourceType ==3 ? '/static/img/payment/select-check.png' : '/static/img/payment/select-off.png'"
                  alt="" class="selectIcon">
              </a>
            </section>
          </template>
          <template v-if="iosReviewVerify">
            <section class="pay-methods" v-if="bankpaychannel != 0 && $store.state.token" @click="selectPayFn(4)">
              <a class="zhifubaoPay">
                <img src="/static/img/payment/sugar.png" alt="" class="apliyIcon">
                <!--  薄荷糖 -->
                <p class="text">
                  <span>薄荷糖支付</span>
                  <span class="sale">（剩余{{sugarTotal| filterMoney}}薄荷糖）</span>
                </p>
                <img
                  :src="paySourceType ==4 ? '/static/img/payment/select-check.png' : '/static/img/payment/select-off.png'"
                  alt="" class="selectIcon">
              </a>
            </section>
          </template>

        </div>

      </div>
      <div class="surePayBtn" v-if="showCountDown" @click="surePayBtnFn()">
        {{$t('payment.surePayBtnFn')}}({{payCountDown}})</div><!--  确认支付 -->
    </div>
    <!-- <d-confirm v-model="modal" :loading="loading" :content="$t('payment.modal')" :ok-text="$t('payment.okText')"
      :cancel-text="$t('payment.cancelText')" @on-ok="modal = false" @on-cancel="handlecancel"></d-confirm> -->
    <d-confirm v-model="modal" :loading="loading" :content="$t('payment.modal')" :ok-text="$t('payment.cancelText') "
      :cancel-text="$t('payment.okText')" @on-ok="handlecancel" @on-cancel="modal = false" ok-color="#f5f5f9"
      cancel-color="#1ce89e"></d-confirm>
    <d-confirm v-model="payResultModal" :loading="payResult" :content="$t('payment.payResultModal')"
      :ok-text="$t('payment.okText2') " :cancel-text="$t('payment.cancelText2')" ok-color="#f5f5f9"
      cancel-color="#1ce89e" @on-ok="payResultNo" @on-cancel="payResultSuccess">
    </d-confirm>

    <!-- 薄荷糖余额不足弹窗 -->
    <d-confirm v-model="sugarTotal0" content="当前薄荷糖余额不足" ok-text="关闭" cancel-text="去充值" ok-color="#f5f5f9"
      cancel-color="#1ce89e" @on-ok="sugarTotal0No" @on-cancel="sugarTotal0Success">
    </d-confirm>

  </div>
</template>

<script>
  var int1;
  var int;
  export default {
    name: "boxDetail",
    components: {},
    data() {
      return {
        iosVersion: '1.0.0',
        sugarTotal0: false,
        sugarTotal: 0, //薄荷糖余额
        iosReviewVerify: false, //显示薄荷糖支付
        alipaychannel: 0, //支付宝支付：2，原生支付宝；9，汇付支付宝；10，宝付支付宝；12，易宝支付宝支付；14，有赞支付宝
        bankpaychannel: 0, //快捷支付银行卡支付：6宝付银行卡，8，易宝绑卡支付；15，有赞快捷支付


        userOrderStatus: 0,
        paySourceType: 3, //1 支付宝 2微信 3银行卡
        apliyCheck: false,
        bankCheck: false,
        weichatusername: "", //汇付支付打开小程序时的username
        weichatPath: "", //汇付支付打开小程序时的路径
        modal: false,
        payResultModal: false, //支付成功失败弹窗
        payResultError: 0, // 支付失败结果展示前提条件，状态接口轮询查询，int++ ，当值为5时提示支付失败
        payResult: false,
        loading: false,
        detail: {
          "id": '',
          "opusName": "",
          "image": "",
          "customerName": "",
        }, //详情数据
        totalprice: "",
        order: "",
        type: 1, //1盲盒 2作品
        orderno: "",
        isWeixin: false, //是否为微信浏览器
        urlEcode: "",
        payCountDown: '00:00', //支付倒计时
        timer: null,
        callbackurl: "",
        isFenZhang: "",
        showCountDown: true,
        bankPaySaleObj: { // 银行卡见面规则展示
          max: '',
          min: '',
          status: false,
        },
        orderStatusSetTimeout: null,
        CURRENTTIME: Date.now(),
        routerPath: '',
      };
    },
    filters: {
      //分转元
      filterMoney(num) {
        return (num / 100).toFixed(2);
      },
      subStr(num) {
        return num.substring(0, 1);
      },
    },
    methods: {
      //确认支付
      surePayBtnFn() {
        let that = this;
        if (this.paySourceType == 1) {
          that.alipay()
        } else if (this.paySourceType == 2) {
          that.wxPay()
        } else if (this.paySourceType == 3) {
          // 宝付银行卡
          that.banklist()
        } else if (this.paySourceType == 4) {
          // 薄荷糖支付
          that.sugarPay()
        }
      },
      selectPayFn(num) {
        this.paySourceType = num
      },
      //支付宝按钮切换
      apliyCheckFn() {
        this.apliyCheck = true
        this.bankCheck = false
      },
      bankCheckFn() {
        this.bankCheck = true
        this.apliyCheck = false
      },

      handlecancel() {
        let that = this;
        let data = {
          orderno: that.$route.query.orderno,
          ordertype: Number(that.type),
          remark: '用户手动取消payment页面',
        };
        this.loading = true;
        //取消订单
        that.$fetchql.Post("opus/goods/order/cancel", data, "noMsg").then((result) => {
          console.log(result);
          this.loading = false;
          this.modal = false;
          clearInterval(that.timer);
          if (result.code == 0) {
            setTimeout(() => {
              if (this.$route.query.redirect) {
                this.$router.push({
                  path: this.$route.query.redirect,
                });
              } else {
                this.$router.push({
                  path: this.routerPath,
                  query: {
                    id: this.$route.query.id,
                  },
                });
              }

            }, 1000);
          } else {
            this.$toast({
              message: result.message,
            });
            setTimeout(() => {
              that.$router.push({
                path: that.$route.query.redirect,
              });
            }, 2000)
          }

        });
      },
      // 用户点击支付成功按钮
      payResultNo() {
        this.$fetchql.Post("order/status", {
          orderType: this.type - 0,
          orderNo: this.$route.query.orderno
        }).then((res) => {
          if (res.code == 0) {
            // 返回订单状态 1.成功 2.失败 3.支付中
            if (res.data == 1) {
              this.$loading.hide();
              setTimeout(() => {
                this.$router.replace({
                  path: "/appOpenBox",
                  query: {
                    orderno: this.$route.query.orderno,
                    ordertype: this.type - 0,
                  },
                });
              }, 1000);
            } else if (res.data == 2) {
              this.$loading.hide();
              this.$toast({
                message: this.$i18nn.t('payment.payErrorText2'),
              });
              setTimeout(() => {
                this.$router.replace({
                  path: this.routerPath,
                  query: {
                    id: this.$route.query.id,
                  },
                });
              }, 2000);
            } else if (res.data == 3) {
              this.CURRENTTIME = Date.now();
              this.payCountDownFn(this.detail);
              this.$loading.hide();
              this.payResultModal = false;
              this.userOrderStatus = res.data;
            } else if (res.data == 0) {
              this.CURRENTTIME = Date.now();
              this.payCountDownFn(this.detail);
              this.$loading.hide();
              this.payResultModal = false;
            }
          }

        })
      },
      // 用户点击支付成功按钮
      payResultSuccess() {
        this.$toast({
          message: this.$i18nn.t('payment.payResultSuccess'),
        });
        this.orderStatus(1);
      },
      //查询订单状态 封装接口 盲盒和作品同一个接口 传值不同
      orderStatus(orderType) {
        let that = this;
        that.payResultModal = false;
        that.payResultError++;
        that.$loading.show();
        if (that.$route.query.orderno) {
          that.$fetchql.Post("order/status", {
            orderType: orderType,
            orderNo: that.$route.query.orderno
          }).then((res) => {
            if (res.code == 0) {
              // 返回订单状态 1.成功 2.失败 3.支付中
              if (res.data == 1) {
                that.$loading.hide();
                setTimeout(function () {
                  that.$router.replace({
                    path: "/appOpenBox",
                    query: {
                      orderno: that.$route.query.orderno,
                      ordertype: orderType,
                    },
                  });
                }, 1000);
              } else if (res.data == 2) {
                that.$loading.hide();
                that.$toast({
                  message: that.$i18nn.t('payment.payErrorText2'),
                });
                setTimeout(function () {
                  that.$router.replace({
                    path: that.routerPath,
                    query: {
                      id: that.$route.query.id,
                    },
                  });
                }, 2000);
              } else if (res.data == 3) {
                that.userOrderStatus = res.data;
                that.orderStatusSetTimeout = setTimeout(() => {
                  if (that.payResultError >= 3) {
                    that.$loading.hide();
                    that.CURRENTTIME = Date.now();
                    that.payCountDownFn(that.detail);
                  } else {
                    that.orderStatus(orderType);
                  }
                }, 3000)
                that.$loading.show();
              } else if (res.data == 0) {
                that.$loading.hide();
                that.payResultModal = false;
                that.CURRENTTIME = Date.now();
                that.payCountDownFn(that.detail);
              }
            }

          })
        }

      },

      //支付宝 alipay
      alipay() {
        // "alipaychannel":支付宝支付：2，原生支付宝；9，汇付支付宝；10，宝付支付宝；12，易宝支付宝支付；14，有赞支付宝
        let that = this;
        clearInterval(that.timer);
        if (that.alipaychannel != 2) {
          setTimeout(function () {
            that.orderStatus(1);
          }, 3000);
          if (that.alipaychannel == 12) {
            that.ybAlipay();
          } else {
            that.dealAlipay();
          }
        } else if (that.alipaychannel == 2) {
          that.paySel();
        }
      },
      wxPay() {
        let that = this;
        clearInterval(that.timer);
        if (that.isWeixin == true && that.isFenZhang == 1) {
          if (that.$route.query.code) {
            that.paySel();
          } else {
            location.href =
              "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe4b8a96939fb0c77&redirect_uri=" +
              that.urlEcode +
              "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
          }
        } else {
          //汇付支付 则调用汇付支付封装的方法
          if (that.isFenZhang != 1) {
            that.hfFnWeixin(1);
          } else if (that.isFenZhang == 1) {
            that.paySel();
          }
        }
      },
      // 薄荷糖支付
      sugarPay() {
        let that = this;
        that.$fetchql.Post('order/pay/v1', {
          orderno: that.$route.query.orderno,
          paychannel: 3,
        }, 'noMsg').then(res => {
          if (res.code == 0) {
            setTimeout(() => {
              that.payResultModal = true;
            }, 1000)
          } else {
            that.sugarTotal0 = true;
          }
        })
      },
      sugarTotal0No() {
        this.sugarTotal0 = false;
      },
      sugarTotal0Success() {
        this.$bridge.callhandler("goRecharge", {}, (token) => {});
      },
      //易宝支付宝支付
      ybAlipay() {
        let that = this;
        that.$fetchql.Post('order/pay/v1', {
          orderno: that.$route.query.orderno,
          paychannel: 12,
        }).then(res => {
          if (res.code == 0) {
            if (this.isInApp) {
              this.$bridge.callhandler("openUrl", res.data.resulturl, (token) => {});
              setTimeout(() => {
                that.payResultModal = true;
              }, 1000)
            }
          }
        })
      },
      // 宝付、汇付、支付宝支付
      dealAlipay() {
        let that = this;
        //alipaychannel 支付宝支付：2，原生支付宝；9，汇付支付宝；10，宝付支付宝；12，易宝支付宝支付；14，有赞支付宝
        var orderdata = {
          orderno: that.$route.query.orderno,
          orderPayType: that.type,
          paychannel: 'alipay_pub',
          clientchannel: 2
        }
        if (that.alipaychannel == 10) {
          orderdata.paychannel = '2'
          // location.href =
          //   "alipays://platformapi/startapp?saId=10000007&qrcode=https://" + location.host + "/payMiddle?orderdata=" +
          //   JSON
          //   .stringify(orderdata)
          if (this.isInApp) {
            this.$bridge.callhandler("openUrl", "alipays://platformapi/startapp?saId=10000007&qrcode=https://" +
              location.host + "/payMiddle?orderdata=" +
              JSON
              .stringify(orderdata), (token) => {});
          }
        } else if (that.alipaychannel == 9) {
          orderdata.paychannel = 'alipay_pub'
          // location.href =
          //   "alipays://platformapi/startapp?saId=10000007&qrcode=https://" + location.host + "/payMiddle?orderdata=" +
          //   JSON
          //   .stringify(orderdata)
          if (this.isInApp) {
            this.$bridge.callhandler("openUrl", "alipays://platformapi/startapp?saId=10000007&qrcode=https://" +
              location.host + "/payMiddle?orderdata=" +
              JSON
              .stringify(orderdata), (token) => {});
          }
        }
        setTimeout(() => {
          that.payResultModal = true;
        }, 1000)
        setTimeout(() => {
          location.href = that.callbackurl;
        }, 3000);
      },
      //汇付/宝付、易宝微信支付
      hfFnWeixin(ordertype) {
        let that = this;
        that.orderno = that.$route.query.orderno;
        let paymentcreateData = {
          callbackurl: that.callbackurl,
          orderno: that.$route.query.orderno,
          ordertype: ordertype,
          paychannel: "wx_lite",
        };
        that.$loading.show();
        that.$fetchql
          .Post("div/paymentcreate", paymentcreateData)
          .then((result) => {
            console.log("汇付支付返回信息");
            console.log(result);
            that.$loading.hide();
            if (result.code == 0) {
              location.href = result.data.expend.wx_h5_pay_url;
            }
          });
      },
      //原生支付
      paySel() {
        let that = this;
        let data = {
          orderno: that.$route.query.orderno,
          buyerid: '',
          paychannel: 2,
          bankid: 0,
        };
        that.$fetchql.Post("order/pay/v1", data).then((result) => {
          if (result.code == 0) {
            clearInterval(that.timer);
            if (that.isInApp) {
              that.$bridge.callhandler("openUrl", result.data.resulturl, (token) => {});
              setTimeout(() => {
                that.payResultModal = true;
              }, 1000)
            }
          } else {
            that.$toast({
              message: result.message,
            });
          }
        });
      },

      /**
       * 格式化时间
       */
      formatDateFn(t) {
        var d = Math.floor(t / 60 / 60 / 24);
        var h = Math.floor(t / 3600);
        var m = Math.floor((t - h * 3600) / 60);
        var s = Math.floor(t - h * 3600 - m * 60);
        var days = d >= 10 ? d : "0" + d;
        var hours = h >= 10 ? h : "0" + h;
        var minutes = m >= 10 ? m : "0" + m;
        var seconds = s >= 10 ? s : "0" + s;
        return minutes + ":" + seconds;
      },
      payCountDownFn(obj) {
        var currentTime = this.CURRENTTIME;
        var endTime = new Date(obj.payExpireTime).getTime();
        var time;
        if (endTime - currentTime > 0) {
          time = (endTime - currentTime) / 1000;
          console.log(time);
        } else {
          time = 0;
        }
        this.timer = setInterval(() => {
          time--;
          if (time <= 0) {
            clearInterval(this.timer);
            this.payCountDown = "00:00";
            if (this.userOrderStatus && this.userOrderStatus == 3) {
              // this.showCountDown = false;

              setTimeout(() => {
                this.$router.push({
                  path: this.routerPath,
                  query: {
                    id: this.$route.query.id,
                  },
                });
              }, 90000);
              return;
            }

            console.log(this.userOrderStatus);
            this.$toast({
              message: this.$i18nn.t('payment.payErrorText1'),
            });
            let data = {
              orderno: this.$route.query.orderno,
              ordertype: Number(this.type),
              remark: '定时结束取消payment页面',
            };
            // this.$fetchql.post("cancelOrder", data).then((result) => {
            this.$fetchql.Post("opus/goods/order/cancel", data, "noMsg").then((result) => {
              if (result.code == 0) {
                if (this.type == 1) {
                  setTimeout(() => {
                    this.$router.push({
                      path: this.routerPath,
                      query: {
                        id: this.$route.query.id,
                      },
                    });
                  }, 2000);
                }
              } else {
                this.$toast({
                  message: result.message,
                });
              }
            });
          } else {
            this.payCountDown = this.formatDateFn(time);
          }
        }, 1000);
      },
      //银行卡列表
      banklist() {
        let that = this;
        let fullPath = this.$route.fullPath
        that.$fetchql.Post("bank/list").then((res) => {
          if (res.code == 0) {
            if (res.data.length == 0) {
              that.$router.push({
                path: "/appAddBank",
                query: {
                  boxSource: that.$route.query.boxSource,
                  source: "appPayment",
                  type: that.$route.query.type,
                  orderno: that.$route.query.orderno,
                  status: that.$route.query.status,
                  id: that.$route.query.id,
                  redirect: fullPath
                  // redirect: fullPath.replace('/payment', '/bankList')
                }
              })
            } else {
              that.$router.push({
                path: "/appBankList",
                query: {
                  boxSource: that.$route.query.boxSource,
                  source: "appPayment",
                  type: that.$route.query.type,
                  orderno: that.$route.query.orderno,
                  status: that.$route.query.status,
                  id: that.$route.query.id,
                }
              })
            }
            // that.banklistLength = res.data.length

          }
        })
      },
      // 获取盲盒活动银行卡减免规则
      getBankPaySaleData() {
        this.$fetchql.Post('pack/pay/discount/status', {
          id: this.$route.query.id * 1,
        }).then(res => {
          if (res.code != 0) return
          this.bankPaySaleObj = Object.assign(this.bankPaySaleObj, res.data);
        })
      },
      // 通过订单号查询相关信息
      getOrderInfoObj() {
        this.$fetchql.Post('opus/goods/order/info', {
          orderNo: this.$route.query.orderno,
        }).then(res => {
          if (res.code != 0) return
          this.payCountDownFn(res.data);
          this.detail = Object.assign(this.detail, res.data)
        })
      },
    },
    beforeDestroy() {
      clearInterval(this.timer);
      clearTimeout(this.orderStatusSetTimeout)
    },
    created() {
      this.$fetchql.Get("time/now").then((result) => {
        if (result.code == 0) {
          this.CURRENTTIME = new Date(result.data).getTime();
        } else {
          this.CURRENTTIME = Date.now();
        }
      })
    },
    mounted() {
      let that = this;
      //判断是否在app内部打开
      let u = navigator.userAgent
      if (u.indexOf('mints') != -1) {
        this.$bridge.callhandler("getVersion", {}, (version) => {
          this.iosVersion = version
        })
        this.$bridge.callhandler("hideNavigationBar", {}, (res) => {})
        this.$bridge.callhandler("inApp", "", (res) => {
          this.isInApp = res;
          if (this.isInApp) {
            this.$bridge.callhandler("getUserToken", {}, (token) => {
              if (token) {
                this.$store.setstate.token(token);
              } else {
                this.$store.setstate.token("");
                this.$bridge.callhandler("getLogin", {}, (token) => {});
              }
            });
          }
        });
      }

      this.routerPath = '/prodDetail'

      that.getOrderInfoObj();
      // that.getBankPaySaleData(); 银行卡减免
      that.callbackurl = window.location.origin + '/payWait?ordertype=1&orderno=' + that.$route.query.orderno;
      // 查询ios 审核模式
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        that.$fetchql.Post("app/reviewverify", {
          "version": that.iosVersion,
          "sourcetype": 24
        }).then((response) => {
          console.log(response);
          if (response.code == 0) {
            that.iosReviewVerify = response.data
            if (that.iosReviewVerify) {
              that.paySourceType = 4;
              that.$fetchql.Post("mints/balance/total", {}).then((res) => {
                that.sugarTotal = res.data
              });
            }
          }
        });
      }
      // 查询支付渠道
      that.$fetchql.Get("pay/channel/v1").then((response) => {
        console.log(response);
        if (response.code == 0) {
          // "wechatpaychannel": 0,        //微信支付：1，原生微信；5，汇付微信；11，宝付微信支付；13，有赞微信支付   暂时不调,时间:2022-07-14
          // "alipaychannel": 2,            //支付宝支付：2，原生支付宝；9，汇付支付宝；10，宝付支付宝；12，易宝支付宝支付；14，有赞支付宝
          // "bankpaychannel": 8        //快捷支付银行卡支付：6宝付银行卡，8，易宝绑卡支付；15，有赞快捷支付

          that.alipaychannel = response.data.alipaychannel;
          that.bankpaychannel = response.data.bankpaychannel;

          that.$fetchql.Post("order/status", {
            orderType: that.type - 0,
            orderNo: that.$route.query.orderno
          }).then((res) => {
            if (res.code == 0 && res.data != 0) {
              that.payResultModal = true;
            }
          })
        }
      });


      if (this.$store.state.token) {
        this.paySourceType = 3;
      } else {
        this.paySourceType = 1;
      }
      that.urlEcode = encodeURIComponent(location.href);
      window.scrollTo(0, 0);
      that.type = that.$route.query.type;

      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      // var ua = window.navigator.userAgent.toLowerCase();
      // if (ua.match(/MicroMessenger/i) == "micromessenger") {
      //   that.isWeixin = true;
      // } else {
      //   that.isWeixin = false;
      // }


    },
  };

</script>

<style scoped="scoped" lang="less">
  .box-img {
    position: relative;

    .pay-count {
      position: absolute;
      left: 50%;
      bottom: 15px;
      margin-left: -152.5px;
      width: 305px;
      height: 40px;
      background: rgba(40, 40, 40, 0.8);
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.5);
      border-radius: 50px;
      border: 1px solid rgba(151, 151, 151, 0.18);
      color: #ffffff;
      text-align: center;
      font-size: 12px;
      line-height: 40px;

      span {
        color: #1ce89e;
        font-size: 14px;
      }
    }
  }

  * {
    margin: 0;
    padding: 0;
  }

  /deep/ .mint-button.is-disabled {
    opacity: 1 !important;
    background: #4f5161 !important;
    color: #8d8f9f !important;
    font-weight: bold !important;
    font-size: 18px !important;
  }

  .content {
    // overflow: hidden;
    // background: #000;
    // min-height: 100vh;

    .topHeader {
      width: 100%;
      position: fixed;
      z-index: 9;
      top: 0;
      height: 94px;
      background: #000;

      .backImg {
        width: 21px;
        height: 9px;
        display: inline-block;
        vertical-align: middle;
        position: absolute;
        left: 15px;
        top: 59px;
      }

      .title {
        font-size: 15px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
        display: inline-block;
        width: 100%;
        margin-top: 56px;
      }

    }
  }

  .box-info {
    margin-top: 55px;

    .buy-info {
      margin: 0 25px;
      padding-bottom: 20px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);

      .customer-info {
        .name {
          font-size: 12px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #7F8080;
          display: flex;
          margin-bottom: 20px;
          justify-content: space-between;

          .rt {
            font-size: 13px;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #FFFFFF;
          }
        }

        .money {
          font-size: 12px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #7F8080;
          display: flex;
          justify-content: space-between;

          .rt {
            font-size: 20px;
            font-family: SourceHanSansCN-Bold, SourceHanSansCN;
            font-weight: bold;
            color: #FFFFFF;

            em {
              display: inline-block;
              vertical-align: middle;

              &.img {
                width: 17px;
                height: 17px;
                background: url(/static/img/payment/sugar.png) no-repeat center center;
                background-size: 17px 17px;
              }

              &.text {
                font-size: 12px;
                font-family: SourceHanSansCN-Bold, SourceHanSansCN;
                font-weight: bold;
                font-style: normal;
                color: #FFFFFF;
                vertical-align: baseline;
              }
            }

            b {
              display: inline-block;
              vertical-align: middle;
            }
          }
        }
      }


    }
  }

  .ic-arrow-line-leftImg {
    width: 21px;
    height: 9px;
    margin-left: 15px;
    margin-top: 25px;
  }


  .topCen {
    margin-top: 112px;

    .topCircleBg {
      text-align: center;

      .detailImg {
        width: 140px;
        height: 122px;
        object-fit: contain;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        margin: 0 auto 5px;
      }

      .topnameDiv {
        text-align: center;

        .topname {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 15px;
          font-family: SourceHanSansCN-Bold, SourceHanSansCN;
          font-weight: bold;
          color: #FFFFFF;
        }

        .dropNum {
          font-size: 13px;
          font-family: SourceHanSansCN-Light, SourceHanSansCN;
          font-weight: 300;
          color: #AAAAAA;
          margin-top: 6px;

          span {
            color: #ffffff;
          }
        }
      }
    }
  }




  .topCen .topCircleBg .hasSaledText {
    position: absolute;
    left: 50%;
    top: 50%;
    color: #f5f4f9;
    margin-left: -20px;
    margin-top: -20px;
    font-size: 18px;
  }



  .selectPayCon {
    padding-top: 35px;
    // background: #141817;
    // box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.5);
    // border-radius: 4px;
    // height: 50px;
  }

  .work-info .explain {
    color: #f5f4f9;
    font-size: 16px;
    line-height: 1.8;
    text-align: left;
    margin-bottom: 8px;
  }

  .work-info .intro {
    font-size: 14px;
    text-align: left;
    color: #8d8f9f;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
  }



  .surePayBtn {
    background: url(/static/img/payment/btn-on.png);
    background-size: 100% 100%;
    height: 45px;
    line-height: 45px;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: bold;
    color: #013925;
    letter-spacing: 1px;
    margin-top: 27.5px;
    margin-left: 15px;
    margin-right: 15px;
  }

  .pay-methods {
    padding: 0 25px 32px;
  }

  .pay-methods:last-child {
    // padding-top: 0;
  }

  .pay-methods a {
    font-size: 14px;
    font-weight: bold;
    color: #0e100f;
  }

  .pay-methods .zhifubaoPay {
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #FFFFFF;

    p.text {
      display: inline-block;
      vertical-align: middle;

      span {

        &.sale {
          font-size: 11px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #FF607A;
          letter-spacing: 0;
        }
      }
    }

    .apliyIcon {
      width: 17px;
      height: 17px;
      vertical-align: middle;
      margin-right: 5px;
    }

    .paypalIcon {
      vertical-align: middle;
      width: 17px;
      height: 17px;
    }

    .selectIcon {
      width: 17px;
      height: 17px;
      vertical-align: middle;
      float: right;
    }
  }

  .pay-methods .weixinPay {
    background: url(/static/img/boxdetail/weixinPayImg.png);
    background-size: 100% 100%;
    text-align: center;
    color: #ffffff;
    padding-left: 45px;
    letter-spacing: 4px;
  }

</style>



// WEBPACK FOOTER //
// src/views/appModel/payment.vue